module.exports = __webpack_public_path__ + "static/img/cuo.2a01794.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cuo.png
// module id = dgsg
// module chunks = 1